import { render, staticRenderFns } from "./ProfessorProgressionReportTable.vue?vue&type=template&id=08c09e36&scoped=true"
import script from "./ProfessorProgressionReportTable.vue?vue&type=script&lang=js"
export * from "./ProfessorProgressionReportTable.vue?vue&type=script&lang=js"
import style0 from "./ProfessorProgressionReportTable.vue?vue&type=style&index=0&id=08c09e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c09e36",
  null
  
)

export default component.exports